import React from "react";
import coin from "../../assets/images/others/coin.png";
import treasure from "../../assets/images/others/treasure.png";
import s from "./style.module.css";

const ProgressBar = ({ QuizPercentage, LessonPercentage }) => {
  const coinArray = [1, 2, 3, 4];
  const chestArray = [1, 2, 3];
  return (
    <div className={s.ProgressBarContainer}>
      <div className={s.LeftContainer}>
        <div className={s.LeftWrapper}>
          <div className={s.LeftTop}>
            {coinArray.map((item) => (
              <div className={s.LeftContent} key={item}>
                <img
                  style={{
                    width: "30%",
                    height: "auto",
                  }}
                  src={coin}
                  alt="coin"
                />
              </div>
            ))}
            {chestArray.map((item) => (
              <div className={s.LeftContent} key={item}>
                <img
                  style={{
                    width: "30%",
                    height: "auto",
                  }}
                  src={treasure}
                  alt="coin"
                />
              </div>
            ))}
          </div>
          <div style={{ flex: 1 }}>
            <div className={s.ProgressbarOuter}>
              <div
                className={s.ProgressbarInner}
                style={{
                  height: "100%",
                  width: `${QuizPercentage + LessonPercentage}%`,
                  // borderRadius: "40px 0px 0px 40px",
                  borderRadius: "40px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className={s.RightContainer}>
        <div className={s.RightWrapper}>
          <div style={{ flex: 1 }}>
            <div className={s.RightContent}>
              <img
                style={{
                  width: "20%",
                  height: "auto",
                }}
                src={coin}
                alt="coin"
              />
              <span>{Math.round(LessonPercentage)}</span>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <div className={s.RightContent}>
              <img
                style={{
                  width: "20%",
                  height: "auto",
                }}
                src={treasure}
                alt="coin"
              />
              <span>{Math.round(QuizPercentage)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
